/**
 * @file LanguageSelector barrel.
 * @description Public entry point for the shared language picker (SE-6508) —
 * the one implementation behind the AI-summary selector and the scout-report
 * translation sheet.
 * @module components/molecules/LanguageSelector
 */
export { default } from "./LanguageSelectorContainer";
export {
  default as LanguageSelectorContainer,
  LANGUAGE_CONTROL_LABEL_KEY,
  LANGUAGE_SELECTOR_TITLE_KEY,
  type LanguageSelectorProps,
} from "./LanguageSelectorContainer";
export {
  SAVE_DEFAULT_LANGUAGE_KEYS,
  SAVE_DEFAULT_LANGUAGE_WARNING_KEY,
  isSaveDefaultPressable,
} from "./LanguageSelectorView";
export type {
  LanguageSelectorSaveDefault,
  LanguageSelectorSaveDefaultRow,
  LanguageSelectorSaveDefaultStatus,
  LanguageSelectorSize,
  LanguageSelectorTrigger,
} from "./LanguageSelectorView";
